import {
    GET_ORDER_CHATBOT_ANALYTICS,
    SET_ORDER_CHATBOT_ANALYTICS,
    SET_ORDER_CHATBOT_ANALYTICS_LOADER,
    SET_ORDER_CHATBOT_ANALYTICS_ERROR,
    RESET_ORDER_CHATBOT_ANALYTICS,
    GET_CHATBOT_CONVERSATIONS,
    SET_CHATBOT_CONVERSATIONS,
    SET_CHATBOT_CONVERSATIONS_LOADER,
    SET_CHATBOT_CONVERSATIONS_ERROR,
    RESET_CHATBOT_CONVERSATIONS
} from '../actionTypes/orderChatbotAnalyticsActionTypes';

const initialState: any = {
    analytics: null,
    isLoading: false,
    error: null,
    conversations: {
        data: [],
        pagination: null,
        filters_applied: null,
        sort: null,
        isLoading: false,
        error: null
    }
}

const orderChatbotAnalyticsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ORDER_CHATBOT_ANALYTICS_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }
        case SET_ORDER_CHATBOT_ANALYTICS:
            return {
                ...state,
                analytics: action.payload,
                isLoading: false,
                error: null
            }
        case SET_ORDER_CHATBOT_ANALYTICS_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        case RESET_ORDER_CHATBOT_ANALYTICS:
            return {
                ...initialState
            }
        
        // Conversations cases
        case SET_CHATBOT_CONVERSATIONS_LOADER:
            return {
                ...state,
                conversations: {
                    ...state.conversations,
                    isLoading: action.payload
                }
            }
        case SET_CHATBOT_CONVERSATIONS:
            return {
                ...state,
                conversations: {
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            }
        case SET_CHATBOT_CONVERSATIONS_ERROR:
            return {
                ...state,
                conversations: {
                    ...state.conversations,
                    error: action.payload,
                    isLoading: false
                }
            }
        case RESET_CHATBOT_CONVERSATIONS:
            return {
                ...state,
                conversations: initialState.conversations
            }
        default:
            return state;
    }
}

export default orderChatbotAnalyticsReducer;